import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";
import RiaSans from "@/views/RiaSans.vue";
import ChobDdag from "@/views/ChobDdag.vue";

const routes = [
  { path: "/", component: Home },
  { path: "/riasans", component: RiaSans },
  { path: "/chobddag", component: ChobDdag },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
